import api from '../utils/api';

const operationalInsightsService = {
  getFinancialRatios: (params = {}) => api.get('/api/operational-insights/financial-ratios', { params }),
  getTransportUtilization: () => api.get('/api/operational-insights/transport-utilization'),
  getHostelOccupancy: () => api.get('/api/operational-insights/hostel-occupancy'),
  getCanteenFinancials: (params = {}) => api.get('/api/operational-insights/canteen-financials', { params }),
  getScholarshipEffectiveness: (academicTermId) => api.get('/api/operational-insights/scholarship-effectiveness', { params: { academic_term_id: academicTermId } }),
  getUtilityTrends: (params = {}) => api.get('/api/operational-insights/utility-trends', { params }),
  getParentEngagement: () => api.get('/api/operational-insights/parent-engagement'),
  getVendorPerformance: () => api.get('/api/operational-insights/vendor-performance'),
  getHealthTrends: (params = {}) => api.get('/api/operational-insights/health-trends', { params }),
  getDisciplineTrends: (params = {}) => api.get('/api/operational-insights/discipline-trends', { params }),
  getSpaceUtilization: (academicTermId) => api.get('/api/operational-insights/space-utilization', { params: { academic_term_id: academicTermId } }),
  getDataQuality: () => api.get('/api/operational-insights/data-quality'),

  // Strategic goals
  listGoals: (params = {}) => api.get('/api/strategic-goals', { params }),
  createGoal: (data) => api.post('/api/strategic-goals', data),
  updateGoal: (id, data) => api.put(`/api/strategic-goals/${id}`, data),
  updateGoalProgress: (id, data) => api.post(`/api/strategic-goals/${id}/progress`, data),
  deleteGoal: (id) => api.delete(`/api/strategic-goals/${id}`),

  // Risk register
  listRisks: (params = {}) => api.get('/api/risk-register', { params }),
  createRisk: (data) => api.post('/api/risk-register', data),
  updateRisk: (id, data) => api.put(`/api/risk-register/${id}`, data),
  deleteRisk: (id) => api.delete(`/api/risk-register/${id}`),
  getRiskSummary: () => api.get('/api/risk-register/summary'),
};

export default operationalInsightsService;
